// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-name[data-v-2b0297a4]{font-size:.875rem;font-weight:500;color:#666}", ""]);
// Exports
module.exports = exports;
